const PRIVACY_OK_KEY = "privacy_ok";

export function getConsentOK() {
  try {
    return localStorage.getItem(PRIVACY_OK_KEY) === "1";
  } catch {
    return false;
  }
}

export function saveConsentOK() {
  try {
    localStorage.setItem(PRIVACY_OK_KEY, "1");
  } catch {
  }
  document.cookie = `privacy=necessary; Max-Age=${28 * 24 * 60 * 60}; Path=/; SameSite=Lax`;
}
